import { Plugin } from '@ckeditor/ckeditor5-core';
import { WidgetToolbarRepository } from '@ckeditor/ckeditor5-widget';
import RecorderUtils from './recorderutils';

export default class RecorderToolbar extends Plugin {
    static get requires() {
        return [ WidgetToolbarRepository, RecorderUtils ];
    }

    static get pluginName() {
        return 'RecorderToolbar';
    }

    afterInit() {
        const editor = this.editor;
        const widgetToolbarRepository = editor.plugins.get(WidgetToolbarRepository);
        const recorderUtils = editor.plugins.get('RecorderUtils');

        widgetToolbarRepository.register('recorder', {
            ariaLabel: 'Recorder toolbar',
            items: editor.config.get('recorder.toolbar') || [],
            getRelatedElement: selection =>
                recorderUtils.getClosestSelectedRecorderWidget(selection)
        });
    }
}
